import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { UniqueMethod } from '../components/UniqueMethod';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsFor } from '../components/WhoIsFor';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { OfferBlock } from '../components/OfferBlock';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-navy-900 text-slate-300 font-body" data-id="element-203">
      <main data-id="element-204">
        <Hero data-id="element-205" />
        <ProblemSection data-id="element-206" />

        <UniqueMethod data-id="element-207" />
        <WhatYouGet data-id="element-208" />
        <WhoIsFor data-id="element-209" />
        <HowItWorks data-id="element-210" />
        <FAQ data-id="element-211" />
        <OfferBlock data-id="element-212" />
      </main>
      <Footer data-id="element-213" />
    </div>;
}